import "primeflex/primeflex.css";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import styles from "./CalculatorSplit.module.css";
import { Button } from "primereact/button";
import MainKeys from "./mainKeys";
import { Dropdown } from "primereact/dropdown";
import { connect } from "react-redux";
import { CHANGE_REQUIRED_FIELD, CHANGE_NOT_REQUIRED_FIELD } from "../../constants/actionTypes";
import agent from "../../agent";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";

const mapStateToProps = (state) => ({
  ...state.results,
});

const mapDispatchToProps = (dispatch) => ({
  changeRequiredField: (name, value) => {
    dispatch({ type: CHANGE_REQUIRED_FIELD, name, value });
  },
  changeNotRequiredField: (name, value) => {
    dispatch({ type: CHANGE_NOT_REQUIRED_FIELD, name, value });
  },
});

const STEP_DEFINITIONS = [
  { id: 0, title: "Шаг 1", subtitle: "Основные данные" },
  { id: 1, title: "Шаг 2", subtitle: "Данные отправителя" },
  { id: 2, title: "Шаг 3", subtitle: "Данные получателя и создание" },
];
const GEOCODE_SEARCH_URL = "https://test-map.slq.kz/search";
const MIN_GEOCODE_QUERY = 3;

const REQUIRED_FIELD_LABELS = {
  pickupDate: "Контрольная дата забора",
  sendLawName: "Наименование юридического лица отправителя",
  sendName: "Имя отправителя",
  sendSurname: "Фамилия отправителя",
  sendIinBin: "ИИН или БИН отправителя",
  sendBuilding: "Номер дома отправителя",
  sendPhone: "Номер телефона отправителя",
  sendStreet: "Улица отправителя",
  receiveLawName: "Наименование юридического лица получателя",
  receiveName: "Имя получателя",
  receiveSurname: "Фамилия получателя",
  receiveIinBin: "ИИН или БИН получателя",
  receiveBuilding: "Номер дома получателя",
  receivePhone: "Номер телефона получателя",
  receiveStreet: "Улица получателя",
  sendIdAddress: "Тип адресного объекта отправителя",
  receiveIdAddress: "Тип адресного объекта получателя",
};

const STEP_FIELDS = {
  0: ["pickupDate"],
  1: ["sendLawName", "sendName", "sendSurname", "sendIinBin", "sendBuilding", "sendPhone", "sendStreet", "sendIdAddress"],
  2: ["receiveLawName", "receiveName", "receiveSurname", "receiveIinBin", "receiveBuilding", "receivePhone", "receiveStreet", "receiveIdAddress"],
};

const FIELD_TO_STEP = Object.entries(STEP_FIELDS).reduce((acc, [stepKey, fields]) => {
  fields.forEach((field) => {
    acc[field] = Number(stepKey);
  });
  return acc;
}, {});

const reusableKeys = [
  { label: "Наименование юридического лица", name: "lawName" },
  { label: "Фамилия", name: "surname" },
  { label: "Имя", name: "name" },
  { label: "Отчество", name: "patronymic" },
  { label: "ИИН или БИН", name: "iinBin" },
  { label: "Улица", name: "street" },
  { label: "Дом", name: "building" },
  { label: "Корпус", name: "housing" },
  { label: "Квартира", name: "apartment" },
  { label: "Офис", name: "office" },
  { label: "Строение", name: "str" },
  { label: "Владение", name: "ownership" },
  { label: "Павильон", name: "pavilion" },
  { label: "Телефон", name: "phone" },
  { label: "Email", name: "email" },
];

const requiredKeys = [
  { label: "Наименование юридического лица", name: "lawName" },
  { label: "Имя", name: "name" },
  { label: "Фамилия", name: "surname" },
  { label: "ИИН или БИН", name: "iinBin" },
  { label: "Номер дома", name: "building" },
  { label: "Номер телефона", name: "phone" },
  { label: "Улица", name: "street" },
];

const prepareKeys = (array, key) => {
  return array.map((obj) => ({
    label: obj.label,
    name: key + obj.name.charAt(0).toUpperCase() + obj.name.slice(1),
  }));
};

const isEmptyValue = (fieldName, value) => {
  if (fieldName === "pickupDate") {
    if (Array.isArray(value)) {
      const firstDate = value[0];
      return !firstDate;
    }
    return !value;
  }

  if (typeof value === "string") {
    return value.trim() === "";
  }

  return value === null || value === undefined || value === "";
};

const getStreetFromSearchResult = (item) => {
  const address = item?.address || {};
  return address.road
    || address.street
    || address.pedestrian
    || address.footway
    || address.path
    || "";
};

const getHouseFromSearchResult = (item) => {
  const address = item?.address || {};
  if (address.house_number) {
    return String(address.house_number);
  }

  const firstToken = String(item?.display_name || "").split(",")[0] || "";
  const matchedHouse = firstToken.match(/\b(\d+[A-Za-zА-Яа-я\/\-]*)\b/);
  return matchedHouse ? matchedHouse[1] : "";
};

const extractSettlementName = (value) => {
  const parts = String(value || "")
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
  return parts.length ? parts[parts.length - 1] : "";
};

const normalizeQueryText = (value) => String(value || "")
  .toLowerCase()
  .replace(/\s+/g, " ")
  .trim();

const buildSearchLabel = (item) => {
  const address = item?.address || {};
  const street = getStreetFromSearchResult(item);
  const house = address.house_number || "";
  const settlement = address.city || address.town || address.village || address.hamlet || address.municipality || "";
  const region = address.state || address.region || "";

  const streetAndHouse = [street, house].filter(Boolean).join(" ").trim();
  return [streetAndHouse, settlement, region].filter(Boolean).join(", ") || item?.display_name || "";
};

const formatDatePickup = (value) => {
  const normalizedValue = Array.isArray(value) ? value[0] : value;
  if (!normalizedValue) {
    return "";
  }

  const date = normalizedValue instanceof Date ? normalizedValue : new Date(normalizedValue);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear());
  return `${day}.${month}.${year}`;
};

const normalizeRouteForOrder = (route) => {
  if (!route || typeof route !== "object") {
    return route;
  }

  const vectors = Array.isArray(route.vectors)
    ? route.vectors.map((vector) => ({
      ...vector,
      daysCnt: vector?.daysCnt ?? 0,
      price: vector?.price ?? 0,
    }))
    : route.vectors;

  return {
    ...route,
    vectors,
  };
};

const Form = (props) => {
  const [sendIdAddress, setSendIdAddress] = useState(30);
  const [receiveIdAddress, setReceiveIdAddress] = useState(30);
  const [activeStep, setActiveStep] = useState(0);
  const [validationErrors, setValidationErrors] = useState({});
  const [stepAlert, setStepAlert] = useState("");
  const [streetAbbrOptions, setStreetAbbrOptions] = useState([]);
  const [geocodeTarget, setGeocodeTarget] = useState("sender");
  const [geocodeQuery, setGeocodeQuery] = useState("");
  const [geocodeLoading, setGeocodeLoading] = useState(false);
  const [geocodeResults, setGeocodeResults] = useState([]);
  const [geocodeError, setGeocodeError] = useState("");
  const [addressMarkers, setAddressMarkers] = useState({ sender: null, receiver: null });
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const targetSettlement = geocodeTarget === "sender"
    ? extractSettlementName(props.from?.nameRu)
    : extractSettlementName(props.to?.nameRu);

  const sendKeys = prepareKeys(reusableKeys, "send");
  const receiveKeys = prepareKeys(reusableKeys, "receive");
  const sendReqKeys = prepareKeys(requiredKeys, "send");
  const receiveReqKeys = prepareKeys(requiredKeys, "receive");

  useEffect(() => {
    agent.StreetAbbr.all().then((response) => setStreetAbbrOptions(response));
  }, []);

  useEffect(() => {
    if (activeStep === 1) {
      setGeocodeTarget("sender");
    } else if (activeStep === 2) {
      setGeocodeTarget("receiver");
    }
  }, [activeStep]);

  useEffect(() => {
    if (!props.onGeocodeMarkerChange) {
      return;
    }

    const markers = Object.values(addressMarkers).filter(Boolean);
    props.onGeocodeMarkerChange(markers);
  }, [addressMarkers, props.onGeocodeMarkerChange]);

  const showMessage = (severity, summary, detail) => {
    toast.current.show({ severity, summary, detail, sticky: false });
  };

  const clearFieldError = (name) => {
    setValidationErrors((prev) => {
      if (!prev[name]) {
        return prev;
      }
      const { [name]: _, ...rest } = prev;
      return rest;
    });
  };

  const setAndClearError = (setter, name, value) => {
    setter(value);
    clearFieldError(name);
  };

  const handleFieldChange = (name, isRequired) => (e) => {
    const value = e.target.value;
    if (isRequired) {
      props.changeRequiredField(name, value);
    } else {
      props.changeNotRequiredField(name, value);
    }
    clearFieldError(name);
  };

  const handlePickupDateChange = (e) => {
    const nextValue = Array.isArray(e.target.value) ? e.target.value[0] || null : e.target.value;
    props.changeRequiredField(e.target.name, nextValue);
    clearFieldError("pickupDate");
  };

  const getFieldValue = (name) => {
    if (name === "sendIdAddress") {
      return sendIdAddress;
    }
    if (name === "receiveIdAddress") {
      return receiveIdAddress;
    }
    return props.requiredFields[name];
  };

  const validateFieldSet = (fields) => {
    const nextErrors = { ...validationErrors };
    fields.forEach((fieldName) => {
      delete nextErrors[fieldName];
    });

    const invalidNames = [];
    fields.forEach((fieldName) => {
      const value = getFieldValue(fieldName);
      if (isEmptyValue(fieldName, value)) {
        invalidNames.push(fieldName);
        nextErrors[fieldName] = `${REQUIRED_FIELD_LABELS[fieldName] || fieldName}: обязательное поле`;
      }
    });

    setValidationErrors(nextErrors);

    return {
      isValid: invalidNames.length === 0,
      invalidNames,
      firstInvalidStep: invalidNames.length ? FIELD_TO_STEP[invalidNames[0]] ?? 0 : null,
    };
  };

  const handleStepClick = (targetStep) => {
    if (targetStep <= activeStep) {
      setActiveStep(targetStep);
      setStepAlert("");
      return;
    }

    const currentStepValidation = validateFieldSet(STEP_FIELDS[activeStep] || []);
    if (currentStepValidation.isValid) {
      setActiveStep(targetStep);
      setStepAlert("");
    } else {
      setStepAlert("Заполните обязательные поля текущего шага, чтобы перейти дальше.");
    }
  };

  const handleNextStep = () => {
    const validation = validateFieldSet(STEP_FIELDS[activeStep] || []);
    if (!validation.isValid) {
      setStepAlert("Проверьте обязательные поля. Незаполненные поля подсвечены красным.");
      return;
    }

    setStepAlert("");
    setActiveStep((prev) => Math.min(prev + 1, STEP_DEFINITIONS.length - 1));
  };

  const handleGeocodeSearch = async () => {
    if (geocodeQuery.trim().length < MIN_GEOCODE_QUERY) {
      setGeocodeError(`Введите минимум ${MIN_GEOCODE_QUERY} символа для поиска адреса.`);
      setGeocodeResults([]);
      return;
    }

    setGeocodeLoading(true);
    setGeocodeError("");

    try {
      const queryRaw = geocodeQuery.trim();
      const normalizedQuery = normalizeQueryText(queryRaw);
      const normalizedSettlement = normalizeQueryText(targetSettlement);
      const finalQuery = normalizedSettlement && !normalizedQuery.includes(normalizedSettlement)
        ? `${targetSettlement}, ${queryRaw}`
        : queryRaw;
      const response = await fetch(
        `${GEOCODE_SEARCH_URL}?format=json&addressdetails=1&accept-language=ru&limit=8&q=${encodeURIComponent(finalQuery)}`
      );
      const payload = await response.json();
      const items = Array.isArray(payload) ? payload : [];
      const normalizedItems = items
        .filter((item) => Number.isFinite(Number(item.lat)) && Number.isFinite(Number(item.lon)))
        .map((item) => ({
          ...item,
          uiLabel: buildSearchLabel(item),
        }));

      setGeocodeResults(normalizedItems);
      if (!normalizedItems.length) {
        setGeocodeError("Ничего не найдено. Уточните запрос.");
      }
    } catch (error) {
      setGeocodeError("Не удалось выполнить поиск адреса. Повторите попытку.");
      setGeocodeResults([]);
    } finally {
      setGeocodeLoading(false);
    }
  };

  const applyGeocodeResult = (item) => {
    const streetField = geocodeTarget === "sender" ? "sendStreet" : "receiveStreet";
    const buildingField = geocodeTarget === "sender" ? "sendBuilding" : "receiveBuilding";
    const streetValue = getStreetFromSearchResult(item);
    const houseValue = getHouseFromSearchResult(item);

    if (streetValue) {
      props.changeRequiredField(streetField, streetValue);
      clearFieldError(streetField);
    }

    if (houseValue) {
      props.changeRequiredField(buildingField, houseValue);
      clearFieldError(buildingField);
    }

    setAddressMarkers((prev) => ({
      ...prev,
      [geocodeTarget]: {
        type: geocodeTarget,
        lat: Number(item.lat),
        lon: Number(item.lon),
        label: item.uiLabel || item.display_name || "",
      },
    }));

    setGeocodeQuery(item.uiLabel || item.display_name || geocodeQuery);
    setGeocodeResults([]);
    setGeocodeError("");
  };

  const postData = () => {
    setLoading(true);
    const data = {
      ...props.requiredFields,
      ...props.notRequiredFields,
    };

    const carrier = {
      name: props.radio.serviceType,
      postal: props.radio.postal,
    };

    const sender = {
      companyName: data.sendLawName,
      email: data.sendEmail,
      extraInfo: data.sendPavilion,
      firstName: data.sendName,
      flat: data.sendApartment,
      house: data.sendBuilding,
      houseKorpus: data.sendHousing,
      iinOrBin: data.sendIinBin,
      lastName: data.sendSurname,
      middleName: data.sendPatronymic,
      office: data.sendOffice,
      phone: data.sendPhone,
      str: data.sendStr,
      street: data.sendStreet,
      streetAbbr: sendIdAddress,
      vlad: data.sendOwnership,
    };

    const receiver = {
      companyName: data.receiveLawName,
      email: data.receiveEmail,
      extraInfo: data.receivePavilion,
      firstName: data.receiveName,
      flat: data.receiveApartment,
      house: data.receiveBuilding,
      houseKorpus: data.receiveHousing,
      iinOrBin: data.receiveIinBin,
      lastName: data.receiveSurname,
      middleName: data.receivePatronymic,
      office: data.receiveOffice,
      phone: data.receivePhone,
      str: data.receiveStr,
      street: data.receiveStreet,
      streetAbbr: receiveIdAddress,
      vlad: data.receiveOwnership,
    };

    const body = {
      request: {
        from: props.from.kato,
        to: props.to.kato,
        weight: props.paidWeight,
        physWeight: props.weight,
        declaredPrice: props.cargoValue,
        placeCnt: props.numPack,
        organizationName: props.selectedOrg?.name || "",
        deliveryFromAddress: props.parcelPickup?.code === 1,
        deliveryToAddress: props.parcelDelivery?.code === 1,
      },
      buildPathRequestId: props.buildPathRequestId ?? null,
      hashCodeRequest: props.hashCodeRequest || null,
      routeId: props.routeId ?? props.selectedRoute?.pathId ?? null,
      route: normalizeRouteForOrder(props.selectedRoute),
      numPack: props.numPack,
      datePickup: formatDatePickup(data.pickupDate),
      sender,
      receiver,
      carrier,
      cargoValue: props.cargoValue,
      productName: props.productName,
      clientOrderNum: `${Math.floor(Date.now() / 1000)}`,
    };

    agent.CalculatedOrder.create(body, props.selectedOrg?.id)
      .then((response) => {
        if (response.error) {
          showMessage("error", "Ошибка", response.error_description);
          return;
        }

        showMessage("success", "Запрос выполнен", `Создан новый заказ ${response.orderNum}`);
      })
      .finally(() => setLoading(false));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!props.canSubmitOrder) {
      setStepAlert("Сначала выберите маршрут в блоке «Выбор тарифа», затем создавайте заказ.");
      showMessage("warn", "Маршрут не выбран", "Выберите маршрут в карточках тарифов или в блоке «Тариф Индивидуальный».");
      return;
    }

    const allRequiredFields = [
      ...STEP_FIELDS[0],
      ...STEP_FIELDS[1],
      ...STEP_FIELDS[2],
    ];

    const validation = validateFieldSet(allRequiredFields);
    if (!validation.isValid) {
      setActiveStep(validation.firstInvalidStep ?? 0);
      setStepAlert("Форма заполнена не полностью. Исправьте подсвеченные поля.");
      return;
    }

    setStepAlert("");
    postData();
  };

  const renderFromArray = (array, reqArr) => {
    return array.map((item) => {
      const isRequired = reqArr.some((requiredItem) => requiredItem.name === item.name);
      const value = isRequired ? props.requiredFields[item.name] : props.notRequiredFields[item.name];
      const error = validationErrors[item.name];

      return (
        <div className="p-fluid" key={item.name}>
          <div className="p-field p-grid">
            <span style={{ color: isRequired ? "red" : "transparent", marginTop: "8px" }}>*</span>
            <label htmlFor={item.name} className="p-col-12 p-md-5">{item.label}</label>
            <div className="p-col-12 p-md-6">
              <InputText
                onChange={handleFieldChange(item.name, isRequired)}
                value={value}
                name={item.name}
                id={item.name}
                type="text"
                className={error ? "p-invalid" : ""}
                placeholder={isRequired ? "обязательное поле" : ""}
              />
              {error && <small className={styles.fieldError}>{error}</small>}
            </div>
          </div>
        </div>
      );
    });
  };

  const renderAddressType = (name, state, setState, opts) => {
    const error = validationErrors[name];

    return (
      <div className="p-fluid">
        <div className="p-field p-grid">
          <span style={{ color: "red", marginTop: "8px" }}>*</span>
          <label htmlFor={name} className="p-col-12 p-md-5">Идентификатор типа адресного объекта</label>
          <div className="p-col-12 p-md-6">
            <Dropdown
              name={name}
              inputId={name}
              value={state}
              options={opts}
              onChange={(e) => setAndClearError(setState, name, e.value)}
              optionLabel="nameRu"
              optionValue="id"
              className={error ? "p-invalid" : ""}
            />
            {error && <small className={styles.fieldError}>{error}</small>}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.orderWrapper}>
      <Toast ref={toast} />
      <h2 className={styles.orderTitle}>Создание заказа</h2>

      <div className={styles.orderStepper}>
        {STEP_DEFINITIONS.map((step) => {
          const isActive = activeStep === step.id;
          const isCompleted = activeStep > step.id;
          return (
            <button
              key={step.id}
              type="button"
              onClick={() => handleStepClick(step.id)}
              className={`${styles.stepItem} ${isActive ? styles.stepItemActive : ""} ${isCompleted ? styles.stepItemDone : ""}`}
            >
              <span className={styles.stepNumber}>{step.id + 1}</span>
              <span className={styles.stepTextWrap}>
                <span className={styles.stepTitle}>{step.title}</span>
                <span className={styles.stepSubtitle}>{step.subtitle}</span>
              </span>
            </button>
          );
        })}
      </div>

      {stepAlert && (
        <div className={styles.stepAlert}>
          <i className="pi pi-info-circle" />
          <span>{stepAlert}</span>
        </div>
      )}

      <div className={styles.geoSearchPanel}>
        <div className={styles.geoSearchHead}>
          <span>Поиск адреса на карте</span>
          <small>Адрес подтянет улицу и дом в форму выбранной стороны</small>
          {targetSettlement && (
            <small className={styles.geoTargetContext}>
              Поиск в населенном пункте: <strong>{targetSettlement}</strong>
            </small>
          )}
        </div>

        <div className={styles.geoSearchControls}>
          <Dropdown
            value={geocodeTarget}
            options={[
              { label: "Отправитель", value: "sender" },
              { label: "Получатель", value: "receiver" },
            ]}
            onChange={(e) => setGeocodeTarget(e.value)}
            className={styles.geoTargetDropdown}
          />

          <InputText
            value={geocodeQuery}
            onChange={(e) => setGeocodeQuery(e.target.value)}
            placeholder="Введите адрес (например: Астана, Сарайшык 5)"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleGeocodeSearch();
              }
            }}
          />

          <Button
            type="button"
            icon="pi pi-search"
            label="Найти"
            loading={geocodeLoading}
            onClick={handleGeocodeSearch}
          />
        </div>

        {geocodeError && <small className={styles.fieldError}>{geocodeError}</small>}

        {geocodeResults.length > 0 && (
          <div className={styles.geoResultList}>
            {geocodeResults.map((item, index) => (
              <button
                type="button"
                key={`${item.lat}_${item.lon}_${index}`}
                className={styles.geoResultItem}
                onClick={() => applyGeocodeResult(item)}
              >
                <i className="pi pi-map-marker" />
                <span>{item.uiLabel || item.display_name}</span>
              </button>
            ))}
          </div>
        )}
      </div>

      <form id="calculatorSplitOrderForm" onSubmit={handleSubmit}>
        {activeStep === 0 && (
          <div className={styles.card}>
            <fieldset className={styles.fieldset}>
              <legend>Основные данные</legend>
              <MainKeys
                result={props.result}
                from={props.from}
                to={props.to}
                cargoValue={props.cargoValue}
                numPack={props.numPack}
                weight={props.weight}
                productName={props.productName}
                productCategory={props.productCategory}
                paidWeight={props.paidWeight}
                radio={props.radio}
                pickupDateError={validationErrors.pickupDate}
                onPickupDateChange={handlePickupDateChange}
              />
            </fieldset>
          </div>
        )}

        {activeStep === 1 && (
          <div className={styles.card}>
            <fieldset className={styles.fieldset}>
              <legend>Данные отправителя</legend>
              {renderFromArray(sendKeys, sendReqKeys)}
              {renderAddressType("sendIdAddress", sendIdAddress, setSendIdAddress, streetAbbrOptions)}
            </fieldset>
          </div>
        )}

        {activeStep === 2 && (
          <div className={styles.card}>
            <fieldset className={styles.fieldset}>
              <legend>Данные получателя</legend>
              {renderFromArray(receiveKeys, receiveReqKeys)}
              {renderAddressType("receiveIdAddress", receiveIdAddress, setReceiveIdAddress, streetAbbrOptions)}
            </fieldset>
          </div>
        )}

        <div className={styles.stepActions}>
          {activeStep > 0 && (
            <Button
              type="button"
              label="Назад"
              icon="pi pi-arrow-left"
              className="p-button-secondary p-button-outlined"
              onClick={() => {
                setActiveStep((prev) => Math.max(prev - 1, 0));
                setStepAlert("");
              }}
            />
          )}

          {activeStep < STEP_DEFINITIONS.length - 1 && (
            <Button
              type="button"
              label="Далее"
              icon="pi pi-arrow-right"
              iconPos="right"
              onClick={handleNextStep}
            />
          )}

          {activeStep === STEP_DEFINITIONS.length - 1 && (
            <span
              className={!props.canSubmitOrder ? "create-order-disabled-tip" : ""}
              data-pr-tooltip={!props.canSubmitOrder ? "Сначала выберите тариф в блоке «Выбор тарифа» выше." : undefined}
              data-pr-position="top"
            >
              <Button
                type="submit"
                label="Создать заказ на доставку"
                loading={loading}
                icon="pi pi-check"
                disabled={!props.canSubmitOrder}
              />
            </span>
          )}
        </div>

        {activeStep === STEP_DEFINITIONS.length - 1 && !props.canSubmitOrder && (
          <small className={styles.submitHint}>
            <i className="pi pi-info-circle" /> Выберите тариф в блоке «Выбор тарифа», и кнопка создания заказа станет активной.
          </small>
        )}
      </form>
      <Tooltip target=".create-order-disabled-tip" />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
